<template>
    <div 
    :class="type === 'upper' ? 'min-w-[120px] upper-link after:bg-main-hover' : 'min-w-[250px] lower-link after:bg-white'" 
    class="relative flex hover:after:w-full hover:after:left-0 after:absolute after:left-[50%] after:bottom-0 after:h-[3px] after:transition-all after:duration-300 after:ease after:w-0"
    @mouseover="showInnerLinks" 
    @mouseleave="hideInnerLinks">
      <router-link 
        :to="link" 
        class="w-full h-full justify-center items-center text-main relative text-base py-2 flex select-none whitespace-nowrap"
        :class="type === 'upper' ? 'text-main' : 'text-white'"
      >
        <ChevronUp 
        v-if="inner && inner.length"
        class="size-4 me-2 duration-500 stroke-[3px] h-[24px] w-[24px]"
        :class="type === 'upper' ? 'stroke-main' : 'stroke-white'"
        />
        {{ text }}
      </router-link>
      <div 
      v-if="inner && inner.length" 
      class="absolute w-full shadow-innerLink 
            overflow-hidden max-h-0 z-50 inner-link 
            top-full left-0 transition-all duration-300 
            ease-in-out hover:delay-500"
      :class="type === 'upper' ? 'bg-white' : 'bg-main'">
        <div 
          v-for="(item, index) in inner"
          :key="item.route"
          class="flex items-center justify-center"
        >
          <router-link
            :to="item.route"
            class="w-full h-full flex justify-center 
                  items-center text-sm py-[8px] px-[16px] 
                  border duration-300 select-none
                  opacity-0 animate-none"
            :class="type === 'upper' ? 'text-main hover:bg-main-hover hover:text-white border-white hover:border-main-hover' : 'text-white hover:bg-white hover:text-main-hover border-main hover:border-main-hover'"
            :style="{ animationDelay: `${index * 0.1}s` }"
          >
            {{ item.title }}
          </router-link>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import "@/Header/Desktop/header.css";
  import { showInnerLinks, hideInnerLinks } from '@/Header/Desktop/header.js';

  import { ChevronUp } from "lucide-vue-next";
  
  export default {
    name: 'LinkComponent',
    components: {
      ChevronUp
    },
    props: {
      text: {
        type: String,
        required: true
      },
      link: {
        type: String,
        required: true
      },
      inner: {
        type: Array,
        required: false
      },
      type: {
        type: String,
        required: true,
        validator: value => ['upper', 'lower'].includes(value)
      }
    },
    methods: {
      showInnerLinks(event) {
        showInnerLinks(event);
      },
      hideInnerLinks(event) {
        hideInnerLinks(event);
      }
    }
  }
  </script>